// import AdminEvents from '@/pages/admin/AdminEvents.vue';
// import AdminCosts from '@/pages/admin/AdminCosts.vue';

const AdminPage = () => import('./Index.vue');
const AdminDashboard = () => import('./AdminDashboard.vue');
const AdminOrganization = () => import('./AdminOrganization.vue');
const AdminEventStream = () =>
  import('../../components/admin/AdminEventStream.vue');
const ZendeskTicketDashboard = () =>
  import('@/pages/admin/ZendeskTicketDashboard.vue');
const AdminBugs = () => import('@/pages/admin/AdminBugs.vue');
const AdminCms = () => import('./AdminCms.vue');
const AdminLocalizations = () => import('@/pages/admin/AdminLocalizations.vue');
const AdminIncidentWizard = () => import('./AdminIncidentWizard.vue');
const AdminRAG = () => import('./AdminRAG.vue');
const AdminRAGChat = () => import('./rag/Chat.vue');
const AdminRAGFiles = () => import('./rag/Files.vue');
const AdminRAGAttention = () => import('./rag/Attention.vue');
const AdminReportGenerator = () => import('./AdminReportGenerator.vue');
const AdminGodMode = () => import('./AdminGodMode.vue');
const AdminSendBulkSms = () => import('./AdminSendBulkSms.vue');
const AdminSendBulkEmail = () => import('./AdminSendBulkEmail.vue');
const AdminMagazine = () => import('./AdminMagazine.vue');
const AdminSentimentAnalysis = () => import('./AdminSentimentAnalysis.vue');
const AdminPortalFiles = () => import('./AdminPortalFiles.vue');
const AdminDebug = () => import('./AdminDebug.vue');
const AdminPhoneHistory = () => import('./AdminPhoneHistory.vue');
const AdminVoiceConsole = () => import('./AdminVoiceConsole.vue');
const AdminVoiceReviewLink = () => import('./AdminVoiceReviewLink.vue');
const AdminVoiceCall = () => import('./AdminVoiceCall.vue');

const routes = [
  {
    path: '/admin',
    component: AdminPage,
    name: 'nav.admin',
    meta: {
      layout: 'authenticated',
      admin: true,
    },
    children: [
      {
        path: 'home',
        name: 'nav.admin_dashboard',
        component: AdminDashboard,
        alias: '',
      },
      {
        path: 'organization/:organization_id',
        name: 'nav.admin_organization',
        component: AdminOrganization,
      },
      // {
      //   path: 'events',
      //   name: 'nav.admin_events',
      //   component: AdminEvents,
      // },
      {
        path: 'event_stream',
        name: 'nav.admin_event_stream',
        component: AdminEventStream,
      },
      {
        path: 'tickets',
        name: 'nav.admin_tickets',
        component: ZendeskTicketDashboard,
      },
      {
        path: 'bugs',
        name: 'nav.bugs',
        component: AdminBugs,
      },
      // {
      //   path: 'costs',
      //   name: 'nav.costs',
      //   component: AdminCosts,
      // },
      {
        path: 'cms',
        name: 'nav.cms',
        component: AdminCms,
      },
      {
        path: 'localizations',
        name: 'nav.localizations',
        component: AdminLocalizations,
      },
      {
        path: 'incident_wizard',
        name: 'nav.incident_wizard',
        component: AdminIncidentWizard,
      },
      {
        path: 'incident_wizard/:incident_id',
        name: 'nav.incident_wizard_detail',
        component: AdminIncidentWizard,
      },
      {
        path: 'rag',
        name: 'nav.rag',
        component: AdminRAG,
        redirect: { name: 'nav.rag_chat' },
        children: [
          {
            path: 'chat',
            name: 'nav.rag_chat',
            component: AdminRAGChat,
          },
          {
            path: 'files',
            name: 'nav.rag_files',
            component: AdminRAGFiles,
          },
          {
            path: 'attention',
            name: 'nav.rag_attention',
            component: AdminRAGAttention,
          },
        ],
      },
      {
        path: 'reports',
        name: 'nav.reports',
        component: AdminReportGenerator,
      },
      {
        path: 'god_mode',
        name: 'nav.god_mode',
        component: AdminGodMode,
      },
      {
        path: 'send_bulk_sms',
        name: 'nav.send_bulk_sms',
        component: AdminSendBulkSms,
      },
      {
        path: 'send_bulk_email',
        name: 'nav.send_bulk_email',
        component: AdminSendBulkEmail,
      },
      {
        path: 'magazine',
        name: 'nav.admin_magazine',
        component: AdminMagazine,
      },
      {
        path: 'sentiment_analysis',
        name: 'nav.sentiment_analysis',
        component: AdminSentimentAnalysis,
      },
      {
        path: 'portal_files',
        name: 'nav.portal_files',
        component: AdminPortalFiles,
      },
      {
        path: 'phone_history',
        name: 'nav.admin_phone_history',
        component: AdminPhoneHistory,
      },
      {
        path: 'voice_console',
        name: 'nav.voice_console',
        component: AdminVoiceConsole,
        // fillHeight: the page fits the screen, and its table scrolls inside.
        meta: { title: '~~AI Call Console', fillHeight: true },
      },
      {
        // The Call Auditor is a tab of the console now.
        path: 'voice_reviews',
        redirect: { name: 'nav.voice_console', query: { view: 'auditor' } },
      },
      {
        // An old link with a review id goes on to the page of its call.
        path: 'voice_reviews/:reviewId',
        name: 'nav.voice_reviews',
        component: AdminVoiceReviewLink,
      },
      {
        // One call: its review, conversation and debug details.
        path: 'voice_calls/:sessionId',
        name: 'nav.voice_call',
        component: AdminVoiceCall,
        meta: { title: '~~AI Call' },
      },
      {
        path: 'debug',
        name: 'nav.debug',
        component: AdminDebug,
      },
    ],
  },
];

export default routes;
